<template>
  <div class="balance-vs-cashflow-button">
    <separator/>
    <div @click="openExplanation" class="explain-balance-vs-balance">
      איך זה השפיע על העו״ש?
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import ModalBus from '../../../../../../../../event-bus/modal-bus';
import Segment from '../../../../../../../../Segment';
import BalanceVsCashflowPopup from './BalanceVsCashflowPopup.vue';

export default {
  name: 'BalanceVsCashflowButton',
  components: {
    Separator: BaseUI.Separator,
  },
  methods: {
    openExplanation() {
      Segment.trackUserInteraction('ExplainBalanceVsCashflowClicked');
      ModalBus.$emit('open', {
        component: BalanceVsCashflowPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  .balance-vs-cashflow-button {
    .explain-balance-vs-balance {
      padding: 17px 0;
      color: $riseup_blue;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
  }
</style>
